import { useState } from "react";
import { Download, FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const todayIT = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Rome" }).format(new Date());
const firstOfMonth = () => `${todayIT().slice(0, 7)}-01`;

export const ExportCard = ({ canPay, canOrders }) => {
  const [from, setFrom] = useState(firstOfMonth());
  const [to, setTo] = useState(todayIT());
  const [busy, setBusy] = useState("");

  const download = async (kind) => {
    setBusy(kind);
    try {
      const { data, headers } = await api.get(`/export/${kind}.csv`, { params: { date_from: from, date_to: to }, responseType: "blob" });
      const name = /filename="([^"]+)"/.exec(headers["content-disposition"] || "")?.[1] || `${kind}.csv`;
      const url = URL.createObjectURL(data);
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      a.click();
      URL.revokeObjectURL(url);
      toast.success("File CSV scaricato");
    } catch (err) {
      let detail = err.response?.data?.detail;
      if (err.response?.data instanceof Blob) { try { detail = JSON.parse(await err.response.data.text()).detail; } catch { /* ignore */ } }
      toast.error(formatApiError(detail));
    } finally { setBusy(""); }
  };

  return (
    <div className="rounded-2xl mo-card p-6" data-testid="export-card">
      <div className="flex items-center gap-2 mb-1"><FileSpreadsheet className="h-5 w-5 text-[#5aa469]" /><h3 className="font-display font-semibold text-2xl">Export per il commercialista</h3></div>
      <p className="text-sm text-gray-500 mb-5">Scarica incassi al tavolo e ordini in formato CSV (si apre con Excel). Scegli il periodo.</p>
      <div className="grid grid-cols-2 gap-3 mb-4 max-w-md">
        <div><Label className="text-xs">Dal</Label><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="mt-1 h-10" data-testid="export-from" /></div>
        <div><Label className="text-xs">Al</Label><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="mt-1 h-10" data-testid="export-to" /></div>
      </div>
      <div className="flex flex-wrap gap-3">
        {canPay && <Button onClick={() => download("payments")} disabled={!!busy} className="rounded-full bg-gray-900 hover:bg-gray-800 text-white" data-testid="export-payments-btn"><Download className="h-4 w-4 mr-2" />{busy === "payments" ? "Preparo…" : "Incassi al tavolo (CSV)"}</Button>}
        {canOrders && <Button onClick={() => download("orders")} disabled={!!busy} variant="outline" className="rounded-full border-gray-300 bg-white hover:bg-gray-50" data-testid="export-orders-btn"><Download className="h-4 w-4 mr-2" />{busy === "orders" ? "Preparo…" : "Ordini e asporto (CSV)"}</Button>}
      </div>
    </div>
  );
};
